/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addCustomerFeedMill } from '../fn/customer-feed-mill/add-customer-feed-mill';
import { AddCustomerFeedMill$Params } from '../fn/customer-feed-mill/add-customer-feed-mill';
import { CustomerFeedMill } from '../models/customer-feed-mill';
import { deleteCustomerFeedMill } from '../fn/customer-feed-mill/delete-customer-feed-mill';
import { DeleteCustomerFeedMill$Params } from '../fn/customer-feed-mill/delete-customer-feed-mill';
import { findByBusinessNumber } from '../fn/customer-feed-mill/find-by-business-number';
import { FindByBusinessNumber$Params } from '../fn/customer-feed-mill/find-by-business-number';
import { findByCustomerFeedMillId } from '../fn/customer-feed-mill/find-by-customer-feed-mill-id';
import { findByCustomerFeedMillId_1 } from '../fn/customer-feed-mill/find-by-customer-feed-mill-id-1';
import { FindByCustomerFeedMillId_1$Params } from '../fn/customer-feed-mill/find-by-customer-feed-mill-id-1';
import { FindByCustomerFeedMillId$Params } from '../fn/customer-feed-mill/find-by-customer-feed-mill-id';
import { findById } from '../fn/customer-feed-mill/find-by-id';
import { FindById$Params } from '../fn/customer-feed-mill/find-by-id';
import { findByName } from '../fn/customer-feed-mill/find-by-name';
import { FindByName$Params } from '../fn/customer-feed-mill/find-by-name';
import { setActiveCustomer } from '../fn/customer-feed-mill/set-active-customer';
import { SetActiveCustomer$Params } from '../fn/customer-feed-mill/set-active-customer';
import { updateCustomerFeedMill } from '../fn/customer-feed-mill/update-customer-feed-mill';
import { UpdateCustomerFeedMill$Params } from '../fn/customer-feed-mill/update-customer-feed-mill';

@Injectable({ providedIn: 'root' })
export class CustomerFeedMillService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addCustomerFeedMill()` */
  static readonly AddCustomerFeedMillPath = '/api/customer/feedMill';

  /**
   * Add Customer Feed Mill.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCustomerFeedMill()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCustomerFeedMill$Response(params: AddCustomerFeedMill$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
    return addCustomerFeedMill(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Customer Feed Mill.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCustomerFeedMill$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCustomerFeedMill(params: AddCustomerFeedMill$Params, context?: HttpContext): Observable<CustomerFeedMill> {
    return this.addCustomerFeedMill$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFeedMill>): CustomerFeedMill => r.body)
    );
  }

  /** Path part for operation `findByBusinessNumber()` */
  static readonly FindByBusinessNumberPath = '/api/customer/feedMill/businessNumber/{businessNumber}/zipCode/{zipCode}';

  /**
   * Find By Business Number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByBusinessNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByBusinessNumber$Response(params: FindByBusinessNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerFeedMill>>> {
    return findByBusinessNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Business Number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByBusinessNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByBusinessNumber(params: FindByBusinessNumber$Params, context?: HttpContext): Observable<Array<CustomerFeedMill>> {
    return this.findByBusinessNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerFeedMill>>): Array<CustomerFeedMill> => r.body)
    );
  }

  /** Path part for operation `findById()` */
  static readonly FindByIdPath = '/api/customer/feedMill/customerFeedMill/{customerFeedMillId}';

  /**
   * Find By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: FindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
    return findById(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: FindById$Params, context?: HttpContext): Observable<CustomerFeedMill> {
    return this.findById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFeedMill>): CustomerFeedMill => r.body)
    );
  }

  /** Path part for operation `findByName()` */
  static readonly FindByNamePath = '/api/customer/feedMill/name/{name}';

  /**
   * Find By Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByName$Response(params: FindByName$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerFeedMill>>> {
    return findByName(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByName(params: FindByName$Params, context?: HttpContext): Observable<Array<CustomerFeedMill>> {
    return this.findByName$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerFeedMill>>): Array<CustomerFeedMill> => r.body)
    );
  }

  /** Path part for operation `updateCustomerFeedMill()` */
  static readonly UpdateCustomerFeedMillPath = '/api/customer/feedMill/{customerFeedMillId}';

  /**
   * Update Customer Feed Mill.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomerFeedMill()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomerFeedMill$Response(params: UpdateCustomerFeedMill$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
    return updateCustomerFeedMill(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Customer Feed Mill.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomerFeedMill$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomerFeedMill(params: UpdateCustomerFeedMill$Params, context?: HttpContext): Observable<CustomerFeedMill> {
    return this.updateCustomerFeedMill$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFeedMill>): CustomerFeedMill => r.body)
    );
  }

  /** Path part for operation `deleteCustomerFeedMill()` */
  static readonly DeleteCustomerFeedMillPath = '/api/customer/feedMill/{customerFeedMillId}';

  /**
   * Delete Customer Feed Mill.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCustomerFeedMill()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomerFeedMill$Response(params: DeleteCustomerFeedMill$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
    return deleteCustomerFeedMill(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Customer Feed Mill.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCustomerFeedMill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomerFeedMill(params: DeleteCustomerFeedMill$Params, context?: HttpContext): Observable<CustomerFeedMill> {
    return this.deleteCustomerFeedMill$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFeedMill>): CustomerFeedMill => r.body)
    );
  }

  /** Path part for operation `setActiveCustomer()` */
  static readonly SetActiveCustomerPath = '/api/customer/feedMill/{customerFeedMillId}/setActive={isActive}';

  /**
   * Set Active Customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setActiveCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveCustomer$Response(params: SetActiveCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
    return setActiveCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Set Active Customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setActiveCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveCustomer(params: SetActiveCustomer$Params, context?: HttpContext): Observable<CustomerFeedMill> {
    return this.setActiveCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFeedMill>): CustomerFeedMill => r.body)
    );
  }

  /** Path part for operation `findByCustomerFeedMillId()` */
  static readonly FindByCustomerFeedMillIdPath = '/api/customer/feedMill/{customerId}';

  /**
   * Find By Customer Feed Mill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByCustomerFeedMillId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerFeedMillId$Response(params: FindByCustomerFeedMillId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerFeedMill>>> {
    return findByCustomerFeedMillId(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Customer Feed Mill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByCustomerFeedMillId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerFeedMillId(params: FindByCustomerFeedMillId$Params, context?: HttpContext): Observable<Array<CustomerFeedMill>> {
    return this.findByCustomerFeedMillId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerFeedMill>>): Array<CustomerFeedMill> => r.body)
    );
  }

  /** Path part for operation `findByCustomerFeedMillId_1()` */
  static readonly FindByCustomerFeedMillId_1Path = '/api/customer/feedMill/{customerId}/feedMill/{feedMillId}';

  /**
   * Find By Customer Feed Mill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByCustomerFeedMillId_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerFeedMillId_1$Response(params: FindByCustomerFeedMillId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
    return findByCustomerFeedMillId_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Customer Feed Mill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByCustomerFeedMillId_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByCustomerFeedMillId_1(params: FindByCustomerFeedMillId_1$Params, context?: HttpContext): Observable<CustomerFeedMill> {
    return this.findByCustomerFeedMillId_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerFeedMill>): CustomerFeedMill => r.body)
    );
  }

}
